import React from 'react';
import Swiper from 'react-id-swiper';
import PreLoginSessionCheck from './PreLoginSessionCheck.js';

// ES6 class-style
class HowWorks extends PreLoginSessionCheck {

	constructor (props) {
		console.log(props);
	    super(props)
	    this.goNext = this.goNext.bind(this)
	    this.goPrev = this.goPrev.bind(this)
	    this.swiper = null
	    this.productDetails = localStorage.getItem('proDetail');
	  }

	  goNext() {
	    if (this.swiper) this.swiper.slideNext()
	  }
	 
	  goPrev() {
	    if (this.swiper) this.swiper.slidePrev()
	  }
	  getProductDetails(){
			console.log(JSON.parse(this.productDetails));
		    if(this.productDetails != {} && this.productDetails != undefined){
		      return JSON.parse(this.productDetails);
		    }
		}

  render() {

  	const params = {
  		slidesPerView: 1,
  		spaceBetween : 50,
  		autoHeight: true,
    }
  	this.proID = localStorage.getItem('product');
  	const gradeName = this.getProductDetails()[this.proID].ClassName;
  	const productCategory = this.getProductDetails()[this.proID].productCategory;
  	var category_ga = this.getProductDetails()[this.proID].productCategory;
	if(category_ga == "EXAM_PREP_CBSE"){
		category_ga = "CBSE Exam Prep";
	}
		
  	return(
		<section className="pd-main product-main">
		 	<div className="container">  
		 	 	<div className="row">   
					<div className="swiper-container sample-lessons">
						<Swiper {...params} className="swiper-wrapper" ref={node => {if(node) this.swiper = node.swiper} }> 
							<div className="swiper-slide">
								<h4>How it Works</h4>
								<img src="../img/t-slider.jpg" alt=""/>
							</div>
							<div className="swiper-slide">
								<h4>Score Card</h4>
								<img src="../img/t-slider-1.jpg" alt=""/>
							</div>
						</Swiper> 
						
						{/* <div className="mt-30 text-center">
							<a data-ga={category_ga+" - "+gradeName+" - Customise to your schools test calendar"} className="surveylink" href="https://www.surveymonkey.com/r/L6THKSD" target="_blank" >Customise to your school's test calendar <i className="material-icons">link</i></a>
						</div> */}
					
						<div className="slider-btns plpsliderbuttons">
			        		<div data-ga={category_ga+" - "+gradeName+" - How the program works - left arrow"} className="swiper-button-prev swp-prev" onClick={this.goPrev}></div>
			        		<div data-ga={category_ga+" - "+gradeName+" - How the program works - right arrow"} className="swiper-button-next swp-next"  onClick={this.goNext}></div>
		        		</div>
					</div>
				</div> 	
				
		 	</div> 
		</section>
  	);
  }
}

export default HowWorks; 


// WEBPACK FOOTER //
// ./src/prelogin/src/components/HowWorks.js